// extracted by mini-css-extract-plugin
export var progressContainer = "_ga-0";